export default __webpack_public_path__ + "9c850e744db952adc611adf7c8a26ac4.png";